import { sendRequest } from "../../hooks/requests/useRequest";

export async function getInformationExternal ()
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `ExternalLaboratories/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}